module.exports = (__webpack_require__(14))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/createClass.js from dll-reference vendor_library
// module id = 45
// module chunks = 0